
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertTrendKPIDataDashboard } from '../services/getAlertTrendKPIDataDeviceDashboard'

export interface AlertTrendKPIDeviceDataState {
  isLoading: boolean
  errorMessage: string | null
  AlertTrendKPIDataDeviceDashboard: AlertTrendKPIDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice
const initialState: AlertTrendKPIDeviceDataState = {
  AlertTrendKPIDataDeviceDashboard: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AlertTrendKPIDataDeviceDataState = createSlice({
  name: 'AlertTrendKPIDataDeviceDataState',
  initialState,
  reducers: {
    AlertTrendKPIDataDeviceLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AlertTrendKPIDataDeviceDashboard: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AlertTrendKPIDataDeviceUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertTrendKPIDataDeviceDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertTrendKPIDataDeviceErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AlertTrendKPIDataDeviceDashboard: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AlertTrendKPIDataDeviceLoadingAction,
  AlertTrendKPIDataDeviceUpdateAction,
  AlertTrendKPIDataDeviceErrorAction
} = AlertTrendKPIDataDeviceDataState.actions

export default AlertTrendKPIDataDeviceDataState.reducer
